<template>
  <div :class="backgroundModifiers">
    <div class="row row-xy row-100">
      <div class="column small-4 large-12 column-100 account-social-badge__avatar">
        <account-social-avatar
          :avatar="userAvatar"
          :showProgress="!isTopLevelTrader"
          :percentage="progressPercentage"
          :progressStrokeColor="progressColor"
          :backgroundStrokeColor="levelColor"
          :theme="avatarTheme"
        >
        </account-social-avatar>
      </div>
      <div class="column small-8 large-12 large-text-center column-100 account-social-badge__text">
        <template v-if="isSocialReady">
          <div class="account-social-badge__headline">
            {{ username }}
          </div>
          <div class="account-social-badge__level">
            <span class="account-social-badge__level-text">{{ level.text }}</span>
            <span class="account-social-badge__level-num">Level {{ level.num }}</span>
          </div>
          <div class="account-social-badge__progress">
            <div :class="progressBarClassModifiers">{{ progressPercentage }}%</div>
            <div
              class="account-social-badge__progress-fill"
              :style="progressBarStyleModifiers"
            ></div>
          </div>
          <div class="account-social-badge__footer">
            <template v-if="isTopLevelTrader"> You are a top-level trader! </template>
            <template v-else>
              {{ progressInfoText }}
            </template>
          </div>
          <span v-if="false" class="account-social-badge__link" @click="showBadgesPopup">
            Your Badges &raquo;
          </span>
        </template>
      </div>
    </div>
  </div>
</template>

<script src="./account-social-badge.js"></script>
<style src="./account-social-badge.scss" lang="scss"></style>
